module.exports = __webpack_public_path__ + "img/3MasterCard500.9cb9a74c.png";